// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-label-settings {
  width: 680px;
}
.dialog-label-settings__title-icon {
  margin-right: 4px;
  margin-bottom: 2px;
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dialog-label-settings__row {
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/wizard/components/Dialogs/DialogLabelSettings/DialogLabelSettings.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;AACI;EACI,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACR;AAEI;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAR","sourcesContent":[".dialog-label-settings {\n  width: 680px;\n}\n.dialog-label-settings__title-icon {\n  margin-right: 4px;\n  margin-bottom: 2px;\n  height: 24px;\n  width: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.dialog-label-settings__row {\n  margin-top: 16px;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
